import { useEffect } from "react";

export const useDocumentTitle = (title) => {
  useEffect(() => {
    document.title = title ? `${title} | Pak Arab Inspection LTD. CO` : "Pak Arab Inspection LTD. CO";
  }, [title]);
};
